// extracted by mini-css-extract-plugin
export var container = "TextWrap-module--container--aa970";
export var containerContent = "TextWrap-module--container__content--69a11";
export var paragraph = "TextWrap-module--paragraph--1e6ac";
export var paragraphSm = "TextWrap-module--paragraph-sm--4fa89";
export var paragraphXs = "TextWrap-module--paragraph-xs--8890f";
export var titleH1 = "TextWrap-module--title-h1--8aca5";
export var titleH2 = "TextWrap-module--title-h2--e5009";
export var titleH3 = "TextWrap-module--title-h3--51205";
export var titleH3Alt = "TextWrap-module--title-h3--alt--18dc8";
export var titleH4 = "TextWrap-module--title-h4--34b49";
export var titleH5 = "TextWrap-module--title-h5--86bb0";